module.exports = __webpack_public_path__ + "img/glogo215.440f8193.png";